module.exports = __webpack_public_path__ + "static/img/hal.76d0869.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/hal.gif
// module id = Us1V
// module chunks = 1